<template>
  <div class="standing">
    <div class="standing-bar">
      <el-row>
        <el-button size="small" icon="el-hg-icon-detail" @click="detail" v-permission="'712'">详情</el-button>
        <el-button size="small" type="default" icon="el-hg-icon-add" @click="insert">新增</el-button>
        <el-button size="small" type="primary" icon="el-hg-icon-edit" @click="update">修改</el-button>
        <el-button size="small" type="danger" icon="el-hg-icon-delete" @click="adelete" v-permission="'715'">删除</el-button>
        <el-button type="primary" size="small" icon="el-hg-icon-refreash" @click="refresh" class="marginLR">刷新</el-button>
        <el-button size="small" icon="el-hg-icon-start" @click="startUse" v-permission="'714'">启用</el-button>
        <el-button size="small" icon="el-hg-icon-stop" @click="stopUse" v-permission="'714'">停用</el-button>
      </el-row>
    </div>
    <!-- list view -->
    <div v-loading="loading" class="standing-list">
      <list class="list" :dataList.sync="aDataList" @detail="detail" ref="tableList" />
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryParams.currentPage" :page-sizes="queryParams.pageSizes" :page-size="queryParams.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
      </div>
    </div>
    <!-- dialogs -->
    <my-dialog :show="bShowDialog" :dialogType.sync="dialogType" :id="currentId" @close="closeDialog" @refresh="refresh" />
  </div>
</template>
<script>
import list from './list';
import MyDialog from './dialog';

export default {
  name: 'sysDicComms',
  components: {
    list,
    MyDialog
  },
  data() {
    return {
      bShowDialog: false,
      dialogType: '',
      currentId: null,
      aDataList: [],
      total: 0,
      loading: true,
      queryParams: {
        pageSizes: [10, 20, 50, 100],
        pageSize: 10,
        currentPage: 1
      }
    };
  },
  computed: {
    selected() {
      let ids = [];
      let sysList = [];
      let textInfo = [];
      this.aDataList.forEach(data => {
        if (data.checked) {
          ids.push({
            value: data.id
          });
          textInfo.push(data.username);
          sysList.push(data);
        }
      });
      return {
        ids,
        list: sysList,
        textInfo
      };
    }
  },
  methods: {
    async getSysDicControllerDicCalculationList() {
      this.startLoading();
      const { bean } = await this.$services.post({
        type: 'SYSDICCOMMS',
        url: 'getSysDicControllerDicCalculationList',
        params: this.queryParams
      });

      for (let i = 0; i < bean.list.length; i++) {
        let item = bean.list[i];
        item.checked = false;
        item.index = bean.pageSize * (bean.pageNum - 1) + (i + 1);
      }
      this.aDataList = bean.list;
      this.total = bean.total;
      this.stopLoading();
    },
    async deleteSysDicControllerDelete(ids) {
      const { status } = await this.$services.post({
        type: 'SYSDICCOMMS',
        url: 'deleteSysDicControllerDelete',
        params: {
          ids: JSON.stringify(ids)
        }
      });

      if (status) {
        this.$message({
          type: 'success',
          message: '删除成功!'
        });
        this.refresh();
      }
      else {
        this.$message({
          type: 'error',
          message: '删除失败!'
        });
      }
    },
    async setSysDicControllerStartUse(ids, state) {
      // state 0：停用，1：启用
      const { status } = await this.$services.post({
        type: 'SYSDICCOMMS',
        url: 'setSysDicControllerStartUse',
        params: {
          ids: JSON.stringify(ids),
          state
        }
      });
      if (status) {
        this.$message({
          type: 'success',
          message: state === 0 ? '停用成功!' : '启用成功'
        });
        this.refresh();
      }
      else {
        this.$message({
          type: 'error',
          message: state === 0 ? '停用失败!' : '启用失败'
        });
      }
    },
    closeDialog() {
      this.bShowDialog = false;
      this.clearChecked();
    },
    showDialog(dialogType) {
      this.dialogType = dialogType;
      this.bShowDialog = true;
    },
    clearChecked() {
      this.$refs['tableList'].$refs['multipleTable'].clearSelection();
    },
    handleSizeChange(size) {
      this.queryParams.pageSize = size;
      this.getSysDicControllerDicCalculationList();
    },
    handleCurrentChange(currentPage) {
      this.queryParams.currentPage = currentPage;
      this.getSysDicControllerDicCalculationList();
    },
    startLoading() {
      this.loading = true;
    },
    stopLoading() {
      this.loading = false;
    },
    startUse() {
      let ids = [];
      let textInfo = [];
      for (let i = 0; i < this.aDataList.length; i++) {
        let item = this.aDataList[i];
        if (item.checked) {
          ids.push({
            value: item.id
          });
          textInfo.push(item.dicCode);
        }
      }
      if (ids.length > 0) {
        this.$confirm(
          `此操作将启用<span style="color:red;padding:0 4px;"> ${textInfo.join(
            ','
          )} </span>, 是否继续?`,
          '提示',
          {
            dangerouslyUseHTMLString: true,
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }
        )
          .then(() => {
            this.setSysDicControllerStartUse(ids, 1);
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消启用'
            });
          });
      }
      else {
        this.$message({
          message: '请选择一个用户',
          type: 'warning'
        });
      }
    },
    stopUse() {
      let ids = [];
      let textInfo = [];
      for (let i = 0; i < this.aDataList.length; i++) {
        let item = this.aDataList[i];
        if (item.checked) {
          ids.push({
            value: item.id
          });
          textInfo.push(item.dicCode);
        }
      }
      if (ids.length > 0) {
        this.$confirm(
          `此操作将停用<span style="color:red;padding:0 4px;"> ${textInfo.join(
            ','
          )} </span>, 是否继续?`,
          '提示',
          {
            dangerouslyUseHTMLString: true,
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }
        )
          .then(() => {
            this.setSysDicControllerStartUse(ids, 0);
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消停用'
            });
          });
      }
      else {
        this.$message({
          message: '请选择一个用户',
          type: 'warning'
        });
      }
    },
    insert() {
      this.currentId = null;
      this.showDialog('insert');
    },
    adelete() {
      // this.bDeleteShowDialog = true;
      let ids = [];
      let textInfo = [];
      let forbid = false;
      for (let i = 0; i < this.aDataList.length; i++) {
        let item = this.aDataList[i];
        if (item.checked) {
          ids.push({
            value: item.id
          });
          textInfo.push(item.dicCode);

          if (item.state === '1') {
            forbid = true;
          }
        }
      }

      /**
       * 有效的数据禁止删除
       */
      if (forbid) {
        this.$message({
          message: '包涵有效数据，禁止删除，请先停用有效数据',
          type: 'warning'
        });
        return;
      }

      if (ids.length > 0) {
        this.$confirm(
          `此操作将永久删除数据<span style="color:red;padding:0 4px;"> ${textInfo.join(
            ','
          )} </span>, 是否继续?`,
          '提示',
          {
            dangerouslyUseHTMLString: true,
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }
        )
          .then(() => {
            this.deleteSysDicControllerDelete(ids);
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            });
          });
      }
      else {
        this.$message({
          message: '请选择一个用户',
          type: 'warning'
        });
      }
    },
    update() {
      if (this.selected.list.length === 0) {
        this.$message({
          message: '请选择一个用户',
          type: 'warning'
        });
        return;
      }
      let [oActiveItem] = this.selected.ids;
      this.currentId = oActiveItem.value;
      this.showDialog('update');
    },
    detail() {
      if (this.selected.list.length === 0) {
        this.$toaster.error('请选择一个用户');
        return;
      }
      let [oActiveItem] = this.selected.ids;
      this.currentId = oActiveItem.value;
      this.showDialog('detail');
    },
    refresh() {
      this.closeDialog();
      this.getSysDicControllerDicCalculationList();
    }
  },
  created() {
    this.getSysDicControllerDicCalculationList();
  }
};
</script>
<style lang="scss" scoped>
// .pagination-box {
//   text-align: right;
// }

// .standing-list {
//   margin-top: 10px;
//   height: calc(100vh - 300px);
// }

.marginLR {
  margin-left: 15px;
  margin-right: 5px;
}
</style>
